.ux-iws-nb-side-navigation-wrapper {
    display: block;
    position: relative;
    margin-top: var(--ux-iws-nb-side-navigation-wrapper--margin-top, 0);

    .ux-iws-nb-side-navigation-wrapper__first-content-element {
        margin-top: calc(
            -1 * var(--ux-iws-nb-side-navigation-wrapper--margin-top, 0)
        ) !important;
    }
}
